import React, { useEffect, useState } from "react";
import axios from "axios";
import SummaryApi from "../common";
import { Link, useNavigate } from "react-router-dom";

export default function MyOrders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [needLogin, setNeedLogin] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const loadOrders = async () => {
      try {
        setLoading(true);

        // STEP 1 — Fetch authenticated user
        const userRes = await axios.get(SummaryApi.current_user.url, {
          withCredentials: true,
        });

        const user = userRes.data?.data;
        if (!user?._id) {
          setNeedLogin(true);
          setLoading(false);
          return;
        }

        // STEP 2 — Fetch orders using userId
        const res = await axios.get(SummaryApi.getUserOrders(user._id), {
          withCredentials: true,
        });

        const d = res.data;

        // Handle different backend formats safely:
        const list =
          d.orders ||
          d.data ||
          d.order ||
          d.orderList ||
          d.items ||
          [];

        setOrders(Array.isArray(list) ? list : []);
        setNeedLogin(false);
      } catch (err) {
        //console.error("Error loading orders:", err);
        setNeedLogin(true);
      } finally {
        setLoading(false);
      }
    };

    loadOrders();
  }, []);

  // ---------------- UI ------------------

  if (loading) return <h2 style={{ textAlign: "center" }}>Loading your orders…</h2>;

  if (needLogin)
    return (
      <div style={{ textAlign: "center", marginTop: 40 }}>
        <h3>Please log in to view orders.</h3>
        <button
          onClick={() => navigate("/login")}
          style={{
            padding: "10px 18px",
            background: "#cc5500",
            color: "#fff",
            borderRadius: 6,
            border: "none",
            marginTop: 10,
          }}
        >
          Login
        </button>
      </div>
    );

  return (
    <div style={{ maxWidth: 800, margin: "30px auto" }}>
      <h2 style={{ fontWeight: "bold" }}>My Orders</h2>

      {orders.length === 0 ? (
        <p>You have no orders yet.</p>
      ) : (
        <div style={{ marginTop: 20 }}>
          {orders.map((o) => (
            <div
              key={o._id}
              style={{
                padding: 15,
                border: "1px solid #ddd",
                borderRadius: 10,
                marginBottom: 15,
              }}
            >
              <h3>Order #{o.orderNumber}</h3>
              <p>Amount: ₹{o.amount}</p>
              <p>Status: {o.status || o.paymentStatus}</p>
              <p>Date: {new Date(o.createdAt).toLocaleString()}</p>

              <Link to={`/order-success/${o._id}`}>
                <button
                  style={{
                    marginTop: 10,
                    background: "#0066cc",
                    color: "#fff",
                    padding: "8px 12px",
                    borderRadius: 6,
                    border: "none",
                  }}
                >
                  View Details
                </button>
              </Link>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
